/**
 * @file App.tsx
 * @description Корневой компонент @chaiberi/admin (phase04 шаг 3).
 *
 * <AuthProvider> снаружи <RouterProvider>, чтобы /login и приватные страницы
 * читали одну и ту же сессию и не дёргали /auth/me повторно при навигации.
 *
 * phase19.31: окно «не тот кабинет у вкладки» (`TabContextConflictDialog`)
 * — одно на приложение: отказы сервера по кабинету вкладки приходят из
 * любого запроса любой страницы.
 */

import { RouterProvider } from "react-router";

import { AuthProvider } from "./auth/AuthProvider";
import { TabContextConflictDialog } from "./components/TabContextConflictDialog";
import { router } from "./router";

export function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <TabContextConflictDialog />
    </AuthProvider>
  );
}
